export default "__VITE_ASSET__BVZu2DbA__"